/*
  FREE CUSTOM DESIGN REQUEST  (Oct 2026)

  A short form the shopper fills in a popup (bottom sheet on phones) or inline
  on the free custom design page:
    1. which course / stadium / city / place
    2. their email
    3. optional notes or a link to a photo

  It is sent through the store's standard contact form, so each request
  arrives as an email at the store's contact address.

  The offer: we design it in a few different styles and email the proofs
  within 48 hours. They pay only if they order a print.

  The wording follows window.opSubject (set in layout/theme.liquid from the
  collection the shopper is looking at). On the custom design page, a
  ?for=golf / stadium / city / circuit / car / park / mountain link sets it.

  Opens from: anything with [data-ocd-open], and links to the custom poster
  product inside page content (not the header, footer or product cards).

  When a request has been sent, a Meta pixel "Lead" event is fired once,
  so a leads campaign can optimise for requests.
*/
(function () {
  if (window.__ocdInit) return;
  window.__ocdInit = true;

  var FLAG = 'ocdSentAt';
  var ALIASES = {
    golf: 'golf course', course: 'golf course', stadium: 'stadium', city: 'city',
    circuit: 'circuit', track: 'circuit', car: 'car', park: 'national park',
    mountain: 'mountain', place: 'place'
  };
  var EXAMPLES = {
    'golf course': 'Pebble Beach, hole 7',
    'stadium': 'Anfield',
    'city': 'Lisbon',
    'circuit': 'Spa-Francorchamps',
    'car': 'My 1987 coupe, in red',
    'national park': 'Yosemite',
    'mountain': 'Mont Blanc',
    'place': 'Our lake house in Muskoka'
  };

  var subject = window.opSubject || 'place';
  try {
    var asked = new URLSearchParams(location.search).get('for');
    if (asked && ALIASES[asked.toLowerCase()]) subject = ALIASES[asked.toLowerCase()];
  } catch (e) {}
  if (!EXAMPLES[subject]) subject = 'place';

  var sheet = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function article(word) { return /^[aeiou]/i.test(word) ? 'an' : 'a'; }

  /* ---------- styles ---------- */
  var css = '' +
    '.ocd{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif}' +
    '.ocd[hidden]{display:none}' +
    '.ocd__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.42);opacity:0;transition:opacity .28s ease}' +
    '.ocd__panel{position:relative;box-sizing:border-box;width:100%;max-width:460px;max-height:94vh;max-height:94dvh;overflow-y:auto;overscroll-behavior:contain;background:#fff;color:#1d1d1f;border-radius:22px 22px 0 0;padding:26px 20px calc(20px + env(safe-area-inset-bottom,0px));transform:translateY(100%);transition:transform .34s cubic-bezier(.32,.72,0,1)}' +
    '.ocd.is-open .ocd__backdrop{opacity:1}' +
    '.ocd.is-open .ocd__panel{transform:translateY(0)}' +
    '.ocd__x{position:absolute;top:14px;right:14px;width:32px;height:32px;border:0;border-radius:50%;background:#f5f5f7;color:#6e6e73;font-size:20px;line-height:1;cursor:pointer}' +
    '.ocd__title{margin:0 40px 0 0;font-size:24px;line-height:1.12;font-weight:600;letter-spacing:-.024em;text-transform:none}' +
    '.ocd__sub{margin:8px 0 18px;font-size:15px;line-height:1.42;color:#6e6e73}' +
    '.ocd__done{text-align:center;padding:18px 0 6px}' +
    '.ocd__done .ocd__title{margin:14px 0 0}' +
    '.ocd__check{width:52px;height:52px;border-radius:50%;background:#1d1d1f;color:#fff;display:inline-flex;align-items:center;justify-content:center}' +
    '.ocd__check svg{width:24px;height:24px}' +
    '.ocd-form{display:grid;gap:12px;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif;text-align:left}' +
    '.ocd-form label{display:grid;gap:6px;font-size:13px;font-weight:600;color:#1d1d1f}' +
    '.ocd-form label span{font-weight:400;color:#6e6e73}' +
    '.ocd-form input[type=text],.ocd-form input[type=email],.ocd-form textarea{box-sizing:border-box;width:100%;border:1px solid #d2d2d7;border-radius:12px;background:#fff;color:#1d1d1f;padding:14px;font:inherit;font-size:16px;font-weight:400;line-height:1.3;-webkit-appearance:none;appearance:none}' +
    '.ocd-form textarea{min-height:76px;resize:vertical}' +
    '.ocd-form input:focus,.ocd-form textarea:focus{outline:none;border-color:#0071e3;box-shadow:0 0 0 3px rgba(0,113,227,.2)}' +
    '.ocd-form__btn{margin-top:4px;border:0;border-radius:980px;background:#0071e3;color:#fff;padding:16px 20px;font:inherit;font-size:17px;font-weight:500;letter-spacing:-.01em;cursor:pointer}' +
    '.ocd-form__btn:disabled{opacity:.6;cursor:wait}' +
    '.ocd-form__btn:focus-visible,.ocd__x:focus-visible,.ocd__link:focus-visible{outline:2px solid #1d1d1f;outline-offset:2px}' +
    '.ocd-form__fine{margin:0;font-size:12px;line-height:1.4;color:#6e6e73;text-align:center}' +
    '.ocd__link{display:inline-block;margin-top:16px;border:0;background:none;font:inherit;font-size:16px;color:#0071e3;cursor:pointer;text-decoration:none}' +
    '@media (min-width:700px){.ocd{align-items:center;padding:24px}.ocd__panel{border-radius:22px;padding:30px 28px 26px;box-shadow:0 24px 60px rgba(0,0,0,.22);transform:translateY(16px) scale(.98);opacity:0;transition:transform .28s ease,opacity .28s ease}.ocd.is-open .ocd__panel{opacity:1;transform:translateY(0) scale(1)}}' +
    '@media (prefers-reduced-motion:reduce){.ocd__backdrop,.ocd__panel{transition:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- the form ---------- */
  function formHtml() {
    var which = subject === 'place' ? 'What should we design?' : 'Which ' + subject + '?';
    return '' +
      '<form class="ocd-form" method="post" action="' + root() + 'contact#ocd" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="contact">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[Request]" value="Free custom design">' +
        '<input type="hidden" name="contact[Type]" value="' + esc(subject) + '">' +
        '<input type="hidden" name="contact[Sent from]" value="' + esc(location.href.split('#')[0]) + '">' +
        '<label>' + esc(which) +
          '<input type="text" name="contact[Design this]" required maxlength="160" placeholder="' + esc(EXAMPLES[subject]) + '" autocomplete="off"></label>' +
        '<label>Your email' +
          '<input type="email" name="contact[email]" required placeholder="you@example.com" autocomplete="email" inputmode="email"></label>' +
        '<label>Anything we should know? <span>Optional</span>' +
          '<textarea name="contact[body]" maxlength="800" placeholder="A date, a score, a colour, or a link to a photo"></textarea></label>' +
        '<button type="submit" class="ocd-form__btn">Send my request</button>' +
        '<p class="ocd-form__fine">A few styles to choose from, by email within 48 hours. No payment, no obligation.</p>' +
      '</form>';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ocd-form')) return;
    try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (err) {}
    var btn = form.querySelector('.ocd-form__btn');
    if (btn) { setTimeout(function () { btn.disabled = true; btn.textContent = 'Sending'; }, 0); }
  });

  /* ---------- the sheet ---------- */
  function build() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'ocd';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ocd__backdrop" data-ocd-close></div>' +
      '<div class="ocd__panel" role="dialog" aria-modal="true" aria-labelledby="ocd-title">' +
        '<button type="button" class="ocd__x" data-ocd-close aria-label="Close">&times;</button>' +
        '<div class="ocd__content"></div>' +
      '</div>';
    document.body.appendChild(sheet);

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      sheet.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
    });
    sheet.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-ocd-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) { e.stopPropagation(); close(); }
    }, true);
    return sheet;
  }

  function show() {
    sheet.hidden = false;
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
  }

  function open() {
    build();
    var title = subject === 'place' ? 'Your place, designed free.' : 'Your ' + subject + ', designed free.';
    var sub = (subject === 'place' ? 'Tell us what to design.' : 'Tell us which ' + subject + '.') +
      ' We design it in a few different styles and email you the proofs within 48 hours. You only pay if you order a print.';
    sheet.querySelector('.ocd__content').innerHTML =
      '<h2 class="ocd__title" id="ocd-title">' + esc(title) + '</h2>' +
      '<p class="ocd__sub">' + esc(sub) + '</p>' + formHtml();
    show();
    setTimeout(function () {
      var first = sheet.querySelector('input[type=text]');
      if (first && window.matchMedia('(min-width: 700px)').matches) { try { first.focus(); } catch (e) {} }
    }, 120);
  }

  function openDone() {
    build();
    sheet.querySelector('.ocd__content').innerHTML =
      '<div class="ocd__done">' +
        '<span class="ocd__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
        '<h2 class="ocd__title" id="ocd-title">Request sent.</h2>' +
        '<p class="ocd__sub">Your designs, in a few different styles, will be in your inbox within 48 hours. If you have a photo, reply to that email with it.</p>' +
        '<button type="button" class="ocd__link" data-ocd-close>Keep browsing</button>' +
      '</div>';
    show();
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 340);
  }

  /* ---------- openers ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var t = e.target.closest && e.target.closest('[data-ocd-open], a[href*="products/custom-poster"], a[href*="pages/free-custom-design"]');
    if (!t) return;
    if (!t.hasAttribute('data-ocd-open')) {
      if (t.closest('header, footer, nav, .header, .footer, product-card, .product-card, .ocd')) return;
    }
    var inline = document.querySelector('[data-ocd-inline]');
    e.preventDefault();
    if (inline) {
      inline.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var f = inline.querySelector('input[type=text]');
      if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (err) {} }, 500);
      return;
    }
    open();
  });

  /* ---------- page wiring ---------- */
  function trackLead() {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Free custom design', content_category: subject });
      }
    } catch (e) {}
  }

  function start() {
    /* Inline form and subject wording on the free custom design page */
    document.querySelectorAll('[data-ocd-inline]').forEach(function (el) { el.innerHTML = formHtml(); });
    document.querySelectorAll('[data-ocd-word]').forEach(function (el) { el.textContent = subject; });
    document.querySelectorAll('[data-ocd-a-word]').forEach(function (el) { el.textContent = article(subject) + ' ' + subject; });

    /* Back from a successful send */
    var sentAt = null;
    try { sentAt = sessionStorage.getItem(FLAG); } catch (e) {}
    if (!sentAt) return;
    var posted = /[?&]contact_posted=true/.test(location.search);
    if (posted) {
      try { sessionStorage.removeItem(FLAG); } catch (e) {}
      try {
        var url = new URL(location.href);
        url.searchParams.delete('contact_posted');
        url.hash = '';
        history.replaceState(null, '', url.toString());
      } catch (e) {}
      trackLead();
      openDone();
    } else if (Date.now() - parseInt(sentAt, 10) > 10 * 60 * 1000) {
      try { sessionStorage.removeItem(FLAG); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
